import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-mystic-800 relative" data-id="element-124">
      <div className="max-w-3xl mx-auto text-center" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-mystic-900 border-2 border-gold-500/30 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-126">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl" data-id="element-127" />

          <div className="relative z-10" data-id="element-128">
            <ShieldCheck className="w-16 h-16 text-gold-400 mx-auto mb-6" data-id="element-129" />
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-130">
              🛡️ Garantía 7 días sin preguntas
            </h2>

            <p className="text-lg text-slate-300 mb-8" data-id="element-131">
              Abrí los 12 Tomos. Revisá los 6 Bonus. Aplicá los Ebooks Élite.
              Usá los protocolos.
            </p>

            <div className="bg-mystic-800/50 p-6 rounded-xl border border-mystic-700 mb-8" data-id="element-132">
              <p className="text-xl font-bold text-white mb-2" data-id="element-133">
                Si no era lo que esperabas →
              </p>
              <p className="text-gold-400 font-bold text-2xl mb-4" data-id="element-134">
                100% de devolución.
              </p>
              <p className="text-slate-400" data-id="element-135">
                Sin preguntas. Sin vueltas. Sin drama.
              </p>
            </div>

            <div className="inline-block px-4 py-2 bg-green-500/10 text-green-400 font-bold text-sm rounded-full tracking-wider" data-id="element-136">
              TASA DE DEVOLUCIONES MENOR AL 2%
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}